import Vue from 'vue'
import Vuex from 'vuex'
import opedModal from './opedModal'

Vue.use(Vuex)

const state = {
  userData: {
		email: '',
    last_name: '',
    first_name: '',
    phone: '',
    birthday: '',
		gender: '',
		plan : '',
		mm01 : '',
		mm02 : '',
	},
  inputData: {
		email: '',
    last_name: '',
    first_name: '',
    phone: '',
    password: '',
    birthday: '',
    gender: '',
		mm01: '',
		mm02: '',
		payment_token:'',
    bank_month: '',
    bank_name: '',
    payment_type: '',
    plan: '',
  }
}

// authority: "member"
// birthday: "1980-01-10 00:00:00"
// display_name: "shiomi"
// email: "shiomi@no-border.co.jp"
// first_name: "友理"
// gender: 0
// id: 2
// last_name: "塩見"
// mm01: null 0,1
// mm02: null 0,1
// new_order_bank_month: null
// new_order_bank_name: null
// new_order_type: null
// phone: "shiomi"
// plan_class: 0
// plan_name: "ブロンズメンバー"

const modules = {
  opedModal,
}

const store = new Vuex.Store({
  state,
  modules,
})

// グローバルにストアを入れた方が良い？？
window.ModalStore = window.ModalStore || store

export default store



// WEBPACK FOOTER //
// ./resources/assets/js/vue/store/index.js